var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_new-document_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9,
    y: 11,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.52,29H7V5H20.34L25,9.62v5.61A9.3,9.3,0,0,1,27,16V8.78L21.16,3H5V31H17.36A9,9,0,0,1,15.52,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,17a7,7,0,1,0,7,7A7,7,0,0,0,23,17Zm4,8H24v3H22V25H19V23h3V20h2v3h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23,15H9v2h8.35A8.94,8.94,0,0,1,23,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.52,19H9v2h5.52A9.59,9.59,0,0,1,15.52,19Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDocuments);
export default __webpack_public_path__ + "static/media/CreateDocuments.7d8cfe93b63fafdea0e0369dab76d991.svg";
export { ForwardRef as ReactComponent };